import axios from 'axios';
import api from '@/api';

// import {LOGIN, CURRENT_USER, LOGOUT}  from '../types';
const LOGIN = 'login'
const CURRENT_USER = 'login'
const LOGOUT = 'login'
const UPDATE_LOGIN_DATA = 'UPDATE_LOGIN_DATA'

const state = {
  token: null,
  isLogged: false,
  currentUser: null,
  updateLoginData: false,
};

const getters = {
  isLogged: state => state.isLogged,
  currentUser: state => state.currentUser,
  isNeedToUpdateLoginData: state => state.updateLoginData,
};

const actions = {
  async login({dispatch, commit}, payload) {
    const json = await api.store('/login', payload);

    if (json.status === 200) {
      commit(LOGIN, json.data.token);
      await dispatch('getUserCurrent');
      return json;
    }

    throw json;
  },
  async checkLogged({dispatch, commit}) {
    const token = localStorage.getItem('token');

    if (token !== null && token !== 'null') {
      commit(LOGIN, token);
      await dispatch('getUserCurrent');
    }
  },
  async getUserCurrent({commit}) {
    const json = await api.show('/users');

    if (json.status === 200) {
      commit(CURRENT_USER, json.data);
      return json;
    }

    throw json;
  },
  async logout({dispatch, commit}) {
    const json = await api.index('/logout');

    if (json.status === 200) {
      commit(CURRENT_USER, null);
      commit(LOGOUT);
      await dispatch('checkLogged')
    }
  },
  setUpdateLoginData({dispatch, commit}, payload) {
    commit(UPDATE_LOGIN_DATA, payload);
  },
};

const mutations = {
  [LOGIN](state, payload) {
    localStorage.setItem('token', payload);
    axios.defaults.headers.common.Authorization = `Bearer ${payload}`;

    state.isLogged = true;
    state.token = payload;
  },
  [CURRENT_USER](state, payload) {
    state.currentUser = payload;
  },
  [LOGOUT](state) {
    localStorage.removeItem('token');
    axios.defaults.headers.common.Authorization = '';

    state.isLogged = false;
    state.token = null;
  },
  [UPDATE_LOGIN_DATA](state, payload) {
    state.updateLoginData = payload;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
